import {
  ADD_ORDER,
  ADD_ORDER_SUCCESS,
  ADD_ORDER_ERROR,
  FETCH_ORDER_DETAIL,
  FETCH_ORDER_DETAIL_SUCCESS,
  FETCH_ORDER_DETAIL_ERROR,
  FETCH_ORDER_DETAIL_RZ,
  FETCH_ORDER_DETAIL_RZ_SUCCESS,
  FETCH_ORDER_DETAIL_RZ_ERROR,
  FETCH_ORDERS,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_ERROR,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_ERROR,
} from '../actionTypes';
// import cloneDeep from 'lodash/cloneDeep';

const INIT_STATE = {
  orders: [],
  modifiedOrder: null,
  error: '',
  loading: false,
  modifying: false,
  orderDetail: null,
  itemPagination: {
    current: 0,
    pageSize: 4,
    total: 0,
  },
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_ORDER:
      return { ...state, modifying: true, error: '', modifiedOrder: null };
    case ADD_ORDER_SUCCESS: {
      return {
        ...state,
        modifying: false,
        modifiedOrder: action.payload,
        // orders: state.orders.concat([{ ...action.payload }]),
        orderDetail: { ...action.payload },
        error: '',
      };
    }
    case ADD_ORDER_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };

    case FETCH_ORDER_DETAIL:
      return { ...state, loading: true, error: '', orderDetail: null };
    case FETCH_ORDER_DETAIL_SUCCESS: {
      return {
        ...state,
        loading: false,
        orderDetail: { ...action.payload },
        error: '',
      };
    }
    case FETCH_ORDER_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_ORDER_DETAIL_RZ:
      return { ...state, loading: true, error: '', orderDetail: null };
    case FETCH_ORDER_DETAIL_RZ_SUCCESS: {
      return {
        ...state,
        loading: false,
        orderDetail: { ...action.payload },
        error: '',
      };
    }
    case FETCH_ORDER_DETAIL_RZ_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case FETCH_ORDERS:
      return { ...state, loading: true, error: '' };
    case FETCH_ORDERS_SUCCESS: {
      const { current, pageSize = 4, total = 0 } = action.pageData;

      return {
        ...state,
        loading: false,
        orders: [...action.payload],
        error: '',
        itemPagination: {
          current,
          pageSize,
          total,
        },
      };
    }
    case FETCH_ORDERS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case UPDATE_ORDER_STATUS:
      return {
        ...state,
        modifying: action.payload,
        error: '',
        modifiedOrder: null,
      };
    case UPDATE_ORDER_STATUS_SUCCESS: {
      /*const newOrders = cloneDeep(state.orders);
      const foundIndex = newOrders.findIndex(
        (order) => order._id === action.payload._id
      );
      newOrders[foundIndex] = cloneDeep(action.payload);*/

      return {
        ...state,
        modifying: false,
        modifiedOrder: action.payload,
        error: '',
      };
    }
    case UPDATE_ORDER_STATUS_ERROR:
      return {
        ...state,
        modifying: false,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};

export default reducer;
